import { mutatorAction } from 'satcheljs';
import type NavigationButton from '../store/schema/NavigationButton';
import getCommandBarStore from '../store/CommandBarStore';

const commandBarActionMutator: (buttonSelected: NavigationButton) => void = mutatorAction(
    'commandBarAction',
    (buttonSelected: NavigationButton): void => {
        getCommandBarStore().navigationButtonSelected = buttonSelected;
    }
);
export default commandBarActionMutator;
